export default __webpack_public_path__ + "static/0139-be184c642fc17c6669b9b2b32c28ef59.png";